<template>
  <div class="authentication">
    <div v-if="loading">
      <BlockUI :message="blockuimsg"></BlockUI>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-sm-12">
          <form class="card auth_form" @submit="login">
              <div class="header">
                <img class="logo" src="@/assets/images/logo.svg" alt="">
                <h5>Herramienta de autor</h5>
              </div>
              <div class="body">
                <div class="input-group mb-3">
                  <input type="email" class="form-control" placeholder="Email"
                    v-model="email">
                  <div class="input-group-append">
                      <span class="input-group-text"><i class="zmdi zmdi-account-circle"></i></span>
                  </div>
                </div>
                <div class="input-group mb-3">
                  <input type="password" class="form-control" placeholder="Password"
                    v-model="password">
                  <div class="input-group-append">
                    <span class="input-group-text"><i class="zmdi zmdi-lock"></i></span>
                     <!--<span class="input-group-text">
                      <a href="/forgotpassword"
                      class="forgot" title="Forgot Password"><i class="zmdi zmdi-lock"></i>
                      </a>
                    </span>-->
                  </div>
                </div>
                <div class="checkbox">
                  <input id="remember_me" type="checkbox">
                  <label for="remember_me">Recuerdame</label>
                </div>
                <button type="submit"
                  class="btn btn-primary btn-block waves-effect waves-light">ENTRAR</button>
                <!-- <div class="signin_with mt-3">
                  <p class="mb-0">or Sign Up using</p>
                  <button class="btn btn-primary btn-icon btn-icon-mini btn-round facebook">
                  <i class="zmdi zmdi-facebook"></i></button>
                  <button class="btn btn-primary btn-icon btn-icon-mini btn-round twitter">
                  <i class="zmdi zmdi-twitter"></i></button>
                  <button class="btn btn-primary btn-icon btn-icon-mini btn-round google">
                  <i class="zmdi zmdi-google-plus"></i></button>
                </div> -->
              </div>
          </form>
          <div class="copyright text-center">
              &copy;
              {{ year }}
              <span>Powered by
                <a href="http://itenlearning.com/" target="_blank">IteNlearning</a>
              </span>
          </div>
        </div>
        <div class="col-lg-8 col-sm-12">
          <div class="card">
            <img src="@/assets/images/signup.svg" alt="Sign In"/>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import * as params from '../../env';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      year: new Date().getFullYear(),
    };
  },
  methods: {
    async login(e) {
      e.preventDefault();

      try {
        this.loading = true;

        // Realizo la autenticación
        const { email, password } = this;
        const response = await this.axios.post('auth/login', { email, password });
        localStorage.setItem('token', response.data.jwt);

        // Obtengo los datos del usuario logueado
        const responseMe = await this.axios.post('auth/me');
        localStorage.setItem(params.default.USER_STORAGE, JSON.stringify(responseMe.data));
        this.loading = false;

        this.$toasted.show('Login satisfactorio', { type: 'success' });
        this.$router.push('panel/contentbrowser');
      } catch (error) {
        this.loading = false;
        this.$toasted.show('Ocurrió un error. Intente de nuevo por favor', { type: 'warning' });
      }
    },
  },
};
</script>
